<template>
  <div class="text">Kies een van de volgende methoden</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ModalHeader'
})
</script>

<style scoped>
.text {
  color: var(--Neutral-5, #191a1f);
  font: 700 16px/2 Montserrat, sans-serif;
}

@media (max-width: 991px) {
  .text {
    max-width: 100%;
  }
}
</style>